import { type CampaignCreative, type DynamicYieldCampaign } from '../../../shared/types';
import { CampaignType } from '../../enums/CampaignType';
import { useCampaigns } from '../../hooks/useCampaigns';
import { DynamicYieldServerRenderedBanner } from './DynamicYieldHeaderBanner/DynamicYieldServerRenderedBanner';
import { HeaderBanner } from './HeaderBanner/HeaderBanner';

type CampaignProps = {
    readonly type?: CampaignType;
};

const Campaign = ({ type = CampaignType.Creative }: CampaignProps): JSX.Element | null => {
    const { hasCampaigns, headerBanner } = useCampaigns<CampaignCreative>(type);

    if (!hasCampaigns || !headerBanner || (!headerBanner.text && type === CampaignType.Creative)) {
        return null;
    }

    if (type === CampaignType.Creative) {
        return <HeaderBanner creative={headerBanner} />;
    }

    const dyCampaign = headerBanner as unknown as DynamicYieldCampaign;

    return <DynamicYieldServerRenderedBanner creative={dyCampaign} />;
};

export { Campaign };
